<template>
  <div class="container">
    <h1>{{ title }}</h1>
    <div class="me">
      <img :src="profileImg">
      <div class="name">{{ name }}</div>
      <div class="nick-name">{{ nickname }}</div>
    </div>
    <biography-list></biography-list>
    <qualification-list></qualification-list>
    <skill-list></skill-list>
    <hackathon-list></hackathon-list>
  </div>
</template>

<script>
  import PageTitle from "../components/modules/PageTitle";
  import BiographyList from "../components/modules/BiographyList"
  import { mapGetters } from 'vuex'
  import SkillList from "../components/modules/SkillList";
  import HackathonList from "../components/modules/HackathonList";
  import QualificationList from "../components/modules/QualificationList"

  export default {
    name: 'About',
    components: {
      HackathonList,
      SkillList,
      BiographyList,
      PageTitle,
      QualificationList
    },
    created: function () {
      this.$store.dispatch('tabAction', 1)
    },
    computed: {
      ...mapGetters('About',{
        'title': 'getTitle',
        'profileImg': 'getProfileImg',
        'name': 'getName',
        'nickname': 'getNickname',
      })
    }

  }
</script>
<style scoped>
  img{
    width: 180px;
    height: auto;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
  }
  .name{
    font-size: 21px;
    font-weight: bold;
  }
  .nick-name{
    font-size: 16px;
  }
  /* .nick-name::before{
    content: '('
  }
  .nick-name::after{
    content: ')'
  } */
</style>



// WEBPACK FOOTER //
// src/views/About.vue